<template>
  <div class="view pa24">
    <div>
      {{ $t('addedServices', 'selectStatus') }}：
      <el-radio
        class="mr10"
        style="margin: 0"
        v-for="(item, index) in radioArr"
        :key="index"
        v-model="radioValue"
        :label="item.value"
        border
        >{{ item.text }}</el-radio
      >
      <el-button type="primary" @click="search">{{ $t('addedServices', 'search') }}</el-button>
      <el-button
        type="primary"
        style="float: right"
        @click="$router.push({ path: '/demandPublishForm' })"
        >{{ $t('addedServices', 'publishDemand') }}</el-button
      >
    </div>
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column
          type="index"
          align="center"
          :label="$t('addedServices', 'serialNumber')"
          show-overflow-tooltip
        />
        <el-table-column prop="createdTime" align="center" :label="$t('addedServices', 'createTime')" />
        <el-table-column prop="name" align="center" :label="$t('addedServices', 'publisher')" />
        <el-table-column prop="description" align="center" show-overflow-tooltip :label="$t('addedServices', 'content')" />
        <el-table-column prop="images" align="center" :label="$t('addedServices', 'image')">
          <template slot-scope="scope">
            <el-image
              style="width: 36px; height: 36px"
              :src="scope.row.imagesList[0]"
              :preview-src-list="scope.row.imagesList"
            >
            </el-image>
            <span>x{{ scope.row.imagesList.length }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="note" align="center" show-overflow-tooltip :label="$t('addedServices', 'remark')" />
        <el-table-column prop="auditing" align="center" :label="$t('addedServices', 'status')">
          <template slot-scope="scope">
            {{
              scope.row.auditing == 0
                ? $t('addedServices', 'pendingReviewStatus')
                : scope.row.auditing == 1
                ? $t('addedServices', 'approved')
                : scope.row.auditing == 2
                ? $t('addedServices', 'rejected')
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('addedServices', 'operation')">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.auditing != 1"
              @click="commitAuditing(scope.row)"
            >
              {{ $t('addedServices', 'submitReview') }}
            </el-button>
            <el-button
              @click="updateDemandSquareStatus(scope.row)"
              class="ml10"
              slot="reference"
              type="text"
            >
              {{ $t('addedServices', 'online') }}
            </el-button>
            <customPopconfirm
              :confirm-button-text="$t('addedServices', 'confirm')"
              :cancel-button-text="$t('addedServices', 'cancel')"
              @confirm="deleteDemandSquare(scope.row)"
              icon="el-icon-info"
              icon-color="red"
              :title="$t('addedServices', 'confirmDelete')">
              <el-button
                class="ml10"
                slot="reference"
                type="text"
                style="color: #fd634e"
              >
                {{ $t('addedServices', 'delete') }}
              </el-button>
            </customPopconfirm>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import customPopconfirm from "@/components/common/customPopconfirm";
import i18nMixin from '@/mixins/i18nMixin';
import {
  queryPageMyDemandSquare,
  commitAuditing,
  updateDemandSquareStatus,
  deleteDemandSquare
} from "@/api/addedServices";
export default {
  mixins: [i18nMixin],
  data() {
    return {
      radioValue: "",
      radioArr: [
        { text: this.$t('addedServices', 'all'), value: "" },
        { text: this.$t('addedServices', 'unsubmitted'), value: "0" },
        { text: this.$t('addedServices', 'reviewed'), value: "1" },
      ],
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
    };
  },
  components: {
    commonTable,
    customPopconfirm
  },
  created() {
    this.queryPageMyDemandSquare();
  },
  methods: {
    /**@method 搜索 */
    search() {
      this.queryPageMyDemandSquare();
    },
    async queryPageMyDemandSquare() {
      let data = {
        pageSize: this.pageSize,
        isDraft: "1",
        auditing: this.radioValue,
      };
      try {
        this.loading = true;
        const result = await queryPageMyDemandSquare(data);
        this.loading = false;
        const {
          pageInfo: { total, list },
        } = result?.data;
        if (!list) {
          this.tableData = [];
          return;
        }
        list.forEach((item) => {
          item.imagesList = JSON.parse(item.images);
        });
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    /**@method 提交审核 */
    async commitAuditing(row) {
      row.isDraft = false;
      try {
        await commitAuditing(row);
        this.queryPageMyDemandSquare();
      } catch (error) {
        console.log(error);
      }
    },
    /**@method 上线 */
    async updateDemandSquareStatus(row) {
      if (row.status == "0" && row.auditing != 1) {
        this.$message({
          message: this.$t('addedServices', 'auditPassedCanOnline'),
        });
        return;
      }
      row.status = row.status == 0;
      row.isDraft = row.status == false;
      try {
        await updateDemandSquareStatus(row);
        this.queryPageMyDemandSquare();
      } catch (error) {
        console.log(error);
      }
    },
     /**@method 删除 */
    async deleteDemandSquare(row) {
      try {
        await deleteDemandSquare(row);
        this.queryPageMyDemandSquare();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>